<template>
  <v-avatar
    class="caption1-desktop text-white"
    :color="avatarColor"
    :image="image"
    :text="text.slice(0, 1).toUpperCase()"
    :class="cssClasses"
    :size="size"
    rounded
  >
    <template v-if="!!image" #default>
      <v-img
        :src="image"
        @load="showImage = true"
      >
        <template #placeholder>
          <span :style="{ lineHeight: `${size}px`}">{{ text.slice(0, 1).toUpperCase() }}</span>
        </template>
      </v-img>
    </template>
  </v-avatar>
</template>

<script setup>
import {computed, defineProps, ref} from 'vue'

const props = defineProps({
  image: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '24',
  },
  color: {
    type: String,
    default: 'primary',
  },
  cssClasses: {
    type: Array,
    default: () => [],
  },
})

const showImage = ref(false)

const avatarColor = computed(() => {
  return showImage.value ? 'transparent' : props.color
})
</script>